import React, { useRef, useEffect, useState } from "react";
import Paper from "@mui/material/Paper"
import "./image.css";
import { Stack } from "@mui/material";
import { Popover, PopoverPaused } from "./popover";
import _, { isObject } from "lodash";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { miImageActions, store } from "../../store/store";
import { defaultImageAnalysisState } from "../../store/context/imageAnalysisSlice";
import { imageAnalysisActions } from "../../store/store";
import DownloadIcon from '@mui/icons-material/Download';
import DrawIcon from '@mui/icons-material/Draw';
import { useNavigate } from 'react-router-dom'
// import { ImageEditor } from "cai-editor";
import { annotationConfig } from '../config'

export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "rgba(32, 38, 43, 0.95)",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgba(32, 38, 43, 0.95)",
    maxWidth: "15rem"
  },
}));



const get_image_url = (image) => {
  return `https://caiproduction002.blob.core.windows.net/ira/audit_images/` + image + `?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D`;
}

const get_thumbnail_url = (thumbnail) => {
  return "https://caiproduction002.blob.core.windows.net/ira/iat/thumbnails/" + thumbnail + "?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D"
}

const get_rgb = (color) => {
  const r = color.replace(/ /g, "").split(",")[0].split("(")[1];
  const g = color.replace(/ /g, "").split(",")[1];
  const b = color.replace(/ /g, "").split(",")[2].split(")")[0];

  return [r, g, b];
}

const colorProfiles = {
  "ai": "rgb(0, 255, 179)",
  "hi": "rgb(255, 30, 244)"
}


export default function ImageAnalysis(props) {
  // console.log(props)
  const canvasRef = useRef(null);
  const dispatch = useDispatch();
  const { imgNo, imageName, imagePath, thumbnailDetails,imageType,imageAudit } = props;
  const [originalImgDim, setOriginalImgDim] = useState({ w: 0, h: 0 })
  const [imageDim, setImageDim] = useState({ w: 0, h: 0 });
  const [open, setOpen] = useState(false);
  const [cursorDim, setCursorDim] = useState([0, 0]);
  const [popoverData, setPopoverData] = useState([]);
  const [popoverPaused, setPopoverPaused] = useState(false);
  const [popoverPausedCoords, setPopoverPausedCoords] = useState([]);
  const [pausedPopoverData, setPausedPopoverData] = useState([]);
  const [cropCoords, setCropCoords] = useState([0, 0, 0, 0]);
  const [pausedCropCoords, setPausedCropCoords] = useState([0, 0, 0, 0]);
  const [popoverLiveDim, setPopoverLiveDim] = useState([0, 0]);
  const [isBlurredImage, setIsBlurredImage] = useState(false);

  const {
    color
  } = useSelector(state => state.miStore);
  const {
    boxTags
  } = useSelector(state => state.miImageStore);

  const navigate = useNavigate()

  const handleScroll = (event) => {
    // zoom in/out on mousewheel scroll (to be added in future)
    const { deltaX, deltaY, deltaMode } = event;

  }

  useEffect(() => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = imagePath;
    img.onload = () => {
      setOriginalImgDim({
        w: img.width,
        h: img.height
      })
    }
  }, [])

  const handlePopoverPause = () => {
    if (open || popoverPaused) {
      setPopoverPaused(!popoverPaused);
      setPopoverPausedCoords(cursorDim);
      setPausedPopoverData(popoverData);
      setPausedCropCoords(cropCoords);
    }
  }


  const handlePopoverLiveDim = (e) => {
    setPopoverLiveDim(e);
  }

  useEffect(() => {

    // applying filters as needed
    let boxes = thumbnailDetails;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = imagePath;
    img.onload = () => {

      canvas.width = img.width;
      canvas.height = img.height;

      ctx.drawImage(img, 0, 0);
      ctx.lineWidth = 5;

      let i = 0;
      if (!boxTags['Disable Boxes']) return;
      console.log('box', boxes.length);
     
      for (let i = 0; i < boxes.length; i++) {
        // drawing default AI boxes
        const type = boxes[i].userId;
        console.log(type,"type",i)
        if (type === 'ai' && (!boxTags['AI answer'])) continue;
        if (type === 'hi' && (!boxTags['HI answer'])) continue;

        let w = boxes[i].width;
        let h = boxes[i].height;
        console.log(w,h,"width height")
        ctx.strokeStyle = type === 'ai' ? colorProfiles['ai'] : colorProfiles['hi'];
        ctx.strokeRect(boxes[i].x, boxes[i].y, w, h);
        
      }


      // using cursor position to figure which thumbnail the cursor is currently hovering on,
      // also, opening & closing popup based on match condition
      if (!popoverPaused) {
        canvas.addEventListener('mousemove', (event) => {
          const x = event.offsetX / props.resize;
          const y = event.offsetY / props.resize;

          const screenX = event.clientX;
          const screenY = event.clientY;
          // console.log(boxes)
          // const match = boxes && boxes.filter(box => ((x > box.x) && (x < box.x)) && (y > box.y) && (y < box.y));
        });
      }

      // closing the popup incase cursor leaves the canvas
      canvas.addEventListener("mouseleave", (event) => {
        if (!popoverPaused) {
          setOpen(false);
        }
      })
    };
  }, [popoverPaused, props, imageDim, boxTags]);

  useEffect(() => {
    const updateScale = () => {
      const ws = window.innerWidth;
      const hs = window.innerHeight;
      const wi = originalImgDim['w'];
      const hi = originalImgDim['h'];

      const ri = wi / hi;
      const rs = ws / hs;

      const scale = rs > ri ? [(wi * hs) / hi, hs] : [ws, (hi * ws) / wi];

      setImageDim({
        w: scale[0] - scale[0] * 0.1,
        h: scale[1] - scale[1] * 0.1,
      })
    }

    updateScale();

    window.addEventListener('resize', updateScale);

    return () => {
      window.removeEventListener('resize', updateScale);
    };
  }, [imageName, originalImgDim])

  // choosing popover view based on popover paused state
  let popoverView
  if (popoverPaused) {
    popoverView = (
      popoverPaused &&
      <PopoverPaused
        display={popoverPaused}
        dim={popoverPausedCoords}
        data={pausedPopoverData}
        cropCoords={pausedCropCoords}
        imageName={props.imageDetails.imageName}
        popoverLiveDim={popoverLiveDim}
      />
    )
  } else {
    popoverView = (
      (open) &&
      <Popover
        display={open}
        dim={cursorDim}
        data={popoverData}
        cropCoords={cropCoords}
        imageName={props.imageDetails.imageName}
        popoverLiveDim={handlePopoverLiveDim}
      />
    )
  }

  const downloadImageDetails = () => {
    // const data = {
    //   rawImageData: props.imageDetails,
    //   hiData: hiData.length > 0 ? hiData : [],
    //   imageDetailsAll: imageDetails,
    //   annotationDetailsAll: annotationDetails
    // }
    // saveJson(data, `${props.imageDetails.imageName}.json`)
  }

  const handleAnnotateImage = () => {
    dispatch(miImageActions.setImageEditorData({
      imageDetails: {
        imageName: imageName,
        imagePath: imagePath,
        data:thumbnailDetails,
        tags: [],
        metadata: [],
        imageAudit: imageAudit,
        imageType: imageType
      },
      classificationConfig: annotationConfig
    }))
    navigate('/image-editor')
  }

  const imageInfoHeader = (
    <Stack
      spacing={0.5}
      direction="row"
      className="annotation-info"
    >
      <span className="img-no">{imgNo}</span>
      <BootstrapTooltip title={`Annotate Image`} placement="top">
        <DrawIcon
          className="img-no"
          onClick={handleAnnotateImage}
        />
      </BootstrapTooltip>
    </Stack>
  )

  return (
    <div
      className="image-analysis"
    >
      <canvas
        id={imgNo}
        onClick={handlePopoverPause}
        onWheel={handleScroll}
        ref={canvasRef}
        style={{ width: `${imageDim['w']}px`, height: `${imageDim['h']}px` }}
      ></canvas>
      {/* {showBoxes && popoverView} */}
      {imageInfoHeader}
      {
        <BootstrapTooltip title={`${imageName}`} placement="top">
          <span className="store-info">{imageName}</span>
        </BootstrapTooltip>}
    </div>
  );
}